import React from "react";
import { isVideov2 } from "../../helpers/isVideo";

function CardMultimedia({ multimedia }) {
  return multimedia?.imageMultimedia?.map((m) => (
    <div className="container-card-multi-media">
      <div className="container-img-shadow">
        {isVideov2(m?.url) ? (
          <video controls src={m?.url} />
        ) : (
          <img src={m?.url} alt="" />
        )}
        <div className="shadow-card-multi-media">.</div>
      </div>
      <h1>{multimedia?.name}</h1>
      <button className="settings_button-border button-b-primary_2">
        <a href={m?.url} rel="noreferrer">
          Descargar
        </a>
      </button>
    </div>
  ));
}

export default CardMultimedia;
